import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { returnInputFieldLength } from "../../../utils/commonFunctions";
import { RollingLoader, ToggleSwitch } from "../../../components/commons";

type AppProps = {
  showAddEditDepartmentModal: boolean;
  toggleAddEditDepartmentModal: () => void;
  isEdit: boolean;
  handleDepartmentNameChange: (data: any) => void;
  departmentName: string;
  status: boolean;
  handleToogleIsStatus: () => void;
  handleAddDepartment: () => void;
  departmentNameError: string;
  departmentUniqueCheckFetching: boolean;
  departmentUniqueCheckMessage: string | null;
};
const AddEditDepartment = ({
  showAddEditDepartmentModal,
  toggleAddEditDepartmentModal,
  isEdit,
  handleDepartmentNameChange,
  departmentName,
  status,
  handleToogleIsStatus,
  handleAddDepartment,
  departmentNameError,
  departmentUniqueCheckFetching,
  departmentUniqueCheckMessage,
}: AppProps) => {

  const preventEnterKey: any = document.getElementById('Add Input')
  if (preventEnterKey) {
    preventEnterKey.addEventListener("keydown", (event: any) => {
      if (event.keyCode === 13 || event.which === 13) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    });
  }

  return (
    <Modal
      isOpen={showAddEditDepartmentModal}
      toggle={toggleAddEditDepartmentModal}
    >
      <ModalHeader className="pt-4 pl-4">
        {`${isEdit ? "Edit" : "Add"} Department`}
      </ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <form>
          <div className="form-group mt-3">
            <div>
              <label
                htmlFor="foldername"
                className={departmentName ? "active" : ""}
              >
                Enter Department Name <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative">
                <input
                  type="text"
                  name="text"
                  // className="form-control"
                  className={`form-control ${
                    !!departmentNameError ? "error-border" : null
                  }`}
                  value={departmentName}
                  autoFocus
                  onChange={(e) => handleDepartmentNameChange(e)}
                  maxLength={200}
                  id="Add Input"
                />

                {departmentUniqueCheckFetching && <RollingLoader />}
              </div>

              {departmentName?.trim().length &&
              departmentUniqueCheckMessage?.includes("already exists") ? (
                <small className="text-danger">
                  Department Name is already in use!
                </small>
              ) : (
                ""
              )}
              {!!departmentNameError && (
                <small className="text-danger">{departmentNameError}</small>
              )}
            </div>

              <span className="input-length">
                {returnInputFieldLength(departmentName?.length, 200)}
              </span>
            </div>

            <div className="col-md-5 p-0">
              <label htmlFor="status">Status</label>
              <ToggleSwitch
                handleToggleChange={handleToogleIsStatus}
                isChecked={status}
              />
            </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <span className="pointer" onClick={toggleAddEditDepartmentModal}>
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleAddDepartment();
            toggleAddEditDepartmentModal();
          }}
          // disabled={!departmentName}
          disabled={
            departmentName?.trim().length === 0 ||
            departmentUniqueCheckMessage?.includes("already exists")
          }
        >
          {isEdit ? "Update Department" : "Add Department"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEditDepartment;
